import {RouteConfig} from 'vue-router/types/router';
import {NavigationDrawerAccess} from '@/enums/_common/NavigationDrawerAccess.enum';

/**
 * Routes of the online make-up rounds ("Nachholrunde online", Saturday). The planner views also check the custom key
 * MANAGE_MAKEUP_ROUNDS (like the backend). Distinct by segment count: /makeup-rounds/:roundId (planning) vs
 * /makeup-rounds/:roundId/:claimId (public yes-page from the parent message, no login).
 */
export const makeupRoundRoutes: RouteConfig[] = [
    {
        path: '/makeup-rounds',
        name: 'Nachholrunden online',
        component: () => import(/* webpackChunkName: "makeup-rounds" */ '@/views/makeup/MakeupRoundsView.vue'),
        meta: {guiAccess: [NavigationDrawerAccess.MAKEUP_ROUNDS]},
    },
    {
        path: '/makeup-rounds/:roundId',
        name: 'Nachholrunde online',
        component: () => import(/* webpackChunkName: "makeup-rounds" */ '@/views/makeup/MakeupRoundView.vue'),
        meta: {guiAccess: [NavigationDrawerAccess.MAKEUP_ROUNDS]},
    },
    {
        path: '/makeup-rounds/:roundId/:claimId',
        name: 'Online-Nachholtermin',
        component: () => import(/* webpackChunkName: "makeup-round-public" */ '@/views/public/MakeupRoundReplyView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
];
